import React, { useEffect } from "react";
import { FormGroup, Label, Input, FormFeedback } from "reactstrap";
import { useField } from "formik";

// App
import { DatePickerProps } from "../../../../types";

const DatePicker: React.FC<DatePickerProps> = ({
  label,
  name,
  onChange,
  type = "date",
  value,
  minDate,
  maxDate,
  isRequired,
}) => {
  const [field, meta, helpers] = useField(name);
  const handleDatePickerChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Formik default handleChange
    field.onChange(e);
    // Custom onChange provided by the parent component
    if (onChange) {
      onChange(e);
    }
  };

  useEffect(() => {
    if (value !== undefined) {
      if (!validateDatePattern(value)) {
        helpers.setValue(convertToDefaultDateFormat(value));
      } else helpers.setValue(value);
    }
  }, [helpers, value]);

  return (
    <FormGroup floating className="mb-3">
      <Input
        type={type}
        id={name}
        name={name}
        placeholder={label}
        value={field.value}
        onChange={handleDatePickerChange}
        invalid={meta?.touched && !!meta?.error}
        min={minDate}
        max={maxDate}
      />
      <Label for={name}>{isRequired ? `${label} *` : label}</Label>
      {meta?.touched && meta?.error && (
        <FormFeedback>{meta?.error}</FormFeedback>
      )}
    </FormGroup>
  );
};

export default DatePicker;

/*TODO*/
const convertToDefaultDateFormat = (selectedDate: string | number): string => {
  let dateParam = new Date(selectedDate);
  if (dateParam !== undefined && !isNaN(dateParam.getTime())) {
    let year = dateParam.getFullYear();
    let month = dateParam.getMonth() + 1;
    let date = dateParam.getDate();
    return `${year}-${month < 10 ? "0" + month : month}-${
      date < 10 ? "0" + date : date
    }`;
  }
  return "";
};

const validateDatePattern = (selectedDate: string): boolean => {
  const datePattern = /^\d{4}-\d{2}-\d{2}$/;
  return datePattern.test(selectedDate);
};
